import React from 'react';
import { BellRing, CheckCircle2, Database, KeyRound, LifeBuoy, PhoneCall } from 'lucide-react';

const WAYS = [
  [KeyRound, '1. Connect it in a minute', "Paste the link to the page where you see your inventory, plus the username and password you use there. Have an API link and key from your software provider? You can use that instead."],
  [CheckCircle2, '2. Check it with 3 of your products', "Type three things customers often ask about and see exactly what your Pro will tell them. When it looks right, you're live."],
  [BellRing, '3. We keep watch for you', "We check your connection every 15 minutes and on every call. If a password changes or something breaks, we email you right away, and again when it's working."],
  [LifeBuoy, 'Need help?', "Our step-by-step guide walks you through it. Still stuck? Email support@frontdeskpro.org."],
];

export const ConnectSystemsSection = () => (
  <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" id="connected-systems" data-testid="landing-connected-systems">
    <div className="max-w-6xl mx-auto grid lg:grid-cols-5 gap-12 items-start">
      <div className="lg:col-span-2">
        <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
          <Database className="w-3.5 h-3.5" /> Pro plan
        </span>
        <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-4">Your Pro knows what's in stock</h2>
        <p className="text-slate-600 mt-4">Connect the system where you keep your inventory and prices. When a caller asks "Do you have this?" or "How much is it?", your Pro checks it live during the call and gives them the real answer.</p>
        <div className="mt-6 flex items-start gap-3 rounded-xl bg-slate-50 border border-slate-200 p-4">
          <PhoneCall className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" />
          <p className="text-sm text-slate-700 italic">"Yes, we have 4 of those in stock at $129 each. Would you like me to hold one for you?"</p>
        </div>
      </div>
      <div className="lg:col-span-3 space-y-4">
        {WAYS.map(([Icon, title, text], i) => (
          <div key={title} className="rounded-2xl border border-slate-200 p-6 hover:border-blue-300 transition-colors" data-testid={`landing-connect-way-${i + 1}`}>
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center"><Icon className="w-5 h-5 text-white" /></div>
              <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
            </div>
            <p className="text-slate-600 text-sm leading-relaxed">{text}</p>
          </div>
        ))}
        <p className="text-xs text-slate-500">Your Pro only reads your stock and prices. It never changes anything. Works with most websites you log in to, and any system that has an API.</p>
      </div>
    </div>
  </section>
);
